import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faAngleDoubleDown,
    faAngleDoubleUp,
    faBars,
    faBolt,
    faBookmark,
    faCalendarTimes,
    faCheck,
    faClock,
    faCloudUploadAlt,
    faCog,
    faCopy,
    faDatabase,
    faDesktop,
    faEdit,
    faExclamationTriangle,
    faExternalLinkAlt,
    faPlus,
    faSave,
    faSearch,
    faSignOutAlt,
    faTimes,
    faTrash,
} from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { MsalProvider, useMsal } from '@azure/msal-react';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { InteractionStatus } from '@azure/msal-browser';
import context from './context';
import './index.css';
import {stores} from './Redux/stores';
import {init} from './Redux/init';
import configureServices from './Services';
import AppAuth from './Components/AppAuth';

/** Renders children only after MsalProvider has finished startup (e.g. handleRedirectPromise). Uses msal-react's inProgress so token is ready before app runs. */
function WaitForMsalReady({ children }: { children: React.ReactNode }) {
    const { inProgress } = useMsal();

    if (inProgress === InteractionStatus.Startup) {
        return null;
    }

    return <>{children}</>;
}

library.add(
    faAngleDoubleDown,
    faAngleDoubleUp,
    faBars,
    faBolt,
    faBookmark,
    faCalendarTimes,
    faCheck,
    faCloudUploadAlt,
    faCog,
    faCopy,
    faDatabase,
    faDesktop,
    faEdit,
    faExclamationTriangle,
    faPlus,
    faSave,
    faTimes,
    faTrash,
    faExternalLinkAlt,
    faSignOutAlt,
    faClock,
    faSearch
);

(async function bootstrap() {
    const services = await configureServices();
    const { actions, reducers } = await stores(services);

    context.registerServices(services);
    context.registerActions(actions);

    const store = init(reducers);
    const target = document.getElementById('root');
    const msalApplication = services.auth.msalApplication;
    const msalClientScopeURL = services.appSettings.GetMsalClientScope();

    ReactDOM.render(
        <MsalProvider instance={msalApplication}>
            <Provider store={store}>
                <Router>
                    <WaitForMsalReady>
                        <AppAuth msalClientScope={msalClientScopeURL} />
                    </WaitForMsalReady>
                </Router>
            </Provider>
        </MsalProvider>,
        target
    );
})();
